import { keys } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';
import {
	getCachedTimestamp,
	setCachedTuple,
	removeCachedTuple,
} from '@confluence/access-requests/entry-points/commonContentIdTimestampTupleCacheUtils';

export const ONE_YEAR_IN_MINUTES = 525600;
export const DEFAULT_MINUTE_LOOKBACK = 5;
export const MINUTE_LOOKBACK_IN_MS = DEFAULT_MINUTE_LOOKBACK * 60 * 1000;
export const LAST_SHOWN_REALTIME_REQUEST_CREATED_AT = keys.LAST_SHOWN_REALTIME_REQUEST_CREATED_AT;

export const isWithinLastFiveMinutes = (timestamp: number) => {
	return Date.now() - timestamp < MINUTE_LOOKBACK_IN_MS;
};

export const isOlderThanFiveMinutes = (timestamp: number) => !isWithinLastFiveMinutes(timestamp);

export const updateLastSeenRealtimeRequestCache = (contentId: string, newTimestamp: number) => {
	setCachedTuple(
		contentId,
		newTimestamp,
		LAST_SHOWN_REALTIME_REQUEST_CREATED_AT,
		isWithinLastFiveMinutes,
	);
};

export const isMoreRecentThanCachedRequestTimestamp = (
	contentId: string,
	incomingRequestTimestamp: number,
) => {
	return (
		incomingRequestTimestamp >
			getCachedTimestamp(contentId, LAST_SHOWN_REALTIME_REQUEST_CREATED_AT) &&
		isWithinLastFiveMinutes(incomingRequestTimestamp)
	);
};

export const clearLastSeenRealtimeRequestCacheIfExpired = (contentId: string) => {
	removeCachedTuple(contentId, LAST_SHOWN_REALTIME_REQUEST_CREATED_AT, isOlderThanFiveMinutes);
};
